import { Col, Row, Space } from "antd"
import moment from 'moment';

interface data {
    nursing_care_type_desc: string // 护理模式
    belong_nursing_name: string  // 护理师
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
}

interface serviceRecordData {
    nursing_care_type_desc: string // 护理模式
    belong_nursing_name: string  // 护理师
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
}

interface Prop {
    data: serviceRecordData[]
    onFetched?: (d?: data[]) => void
}

export default function (prop: Prop) {

    return <div className="modules">
        {/* 月嫂中心 -> 到府客户管理 -> 客户详情 -> 服务信息 */}
        <div className="top clear">
            <h3 className="fl"><span className="fl">服务信息</span></h3>
        </div>

        <div className="content" >
            {prop.data.map((el: data) => <Row style={{ width: '100%', marginTop: 15, marginLeft: 20 }}>
                <Col span={6}>
                    <Space wrap>
                        <p>护理模式：</p>
                        <p className="right-text">{el.nursing_care_type_desc}</p>
                    </Space>
                </Col>

                <Col span={6}>
                    <Space wrap>
                        <p>护理师：</p>
                        <p className="right-text">{el.belong_nursing_name}</p>
                    </Space>
                </Col>

                <Col span={7}>
                    <Space wrap>
                        <p>服务时间段：</p>
                        <p className="right-text">{moment(el.service_start_date).format('YYYY-MM-DD')} 至 {moment(el.service_end_date).format('YYYY-MM-DD')}</p>
                    </Space>
                </Col>
            </Row>)}
        </div>
    </div>
}